import { Stack } from '@mantine/core';
import { BasicFieldInputs } from '../components/BasicFieldInputs';

export const TitleField = ({
  field,
  setField,
}: {
  field: any;
  setField: (field: any) => void;
}) => {
  return (
    <Stack gap="md">
      <BasicFieldInputs
        fields={['title']}
        fieldValues={field}
        requiredFields={['title']}
        onChange={(key, value) => setField({ ...field, [key]: value })}
      />
    </Stack>
  );
};
